import { useEffect, FC } from "react";
import { useHistory } from "react-router-dom";
import configAxios from "./configAxios";
import storageListener from "./storageListener";

const SetupConfig: FC = () => {
  const history = useHistory();

  useEffect(() => {
    const redirect = () => history.replace("/auth/login");

    configAxios(redirect);

    const handleStorageChange = (e: any) => {
      if (history?.location?.pathname !== "/proforma-invoice") {
        storageListener(redirect, e);
      }
    };

    window.addEventListener("storage", handleStorageChange, false);

    return () => {
      window.removeEventListener("storage", handleStorageChange, false);
    };
  }, [history]);

  return null;
};

export default SetupConfig;
